// utils/getDefaultMessage.js
const getDefaultMessage = (type, name = "") => {
  switch (type) {
    case "birthday":
      return `Happy Birthday ${
        name || ""
      }! 🎉 Wishing you a day filled with joy and laughter.`;
    case "wedding":
      return `Congratulations on your wedding ${
        name || ""
      }! 💍 Wishing you a lifetime of love.`;
    case "graduation":
      return `Hats off to you ${name || ""}! 🎓 So proud of your achievement!`;
    case "baby-shower":
      return `Wishing you all the best with your new bundle of joy! 👶💖`;
    case "farewell":
      return `Goodbye and good luck ${name || ""}! 🍀 You'll be missed!`;
    case "anniversary":
      return `Happy Anniversary ${name || ""}! 💕 Here's to many more years.`;
    default:
      return `Wishing you a wonderful day, ${name || ""}! 🎉`;
  }
};

export default getDefaultMessage;
